import React, { useCallback } from 'react';
import { MyButton } from '../index';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SuccessfulImage from 'assets/images/Successful.svg';
import { FormattedMessage } from 'react-intl';

import './styles.scss';

const SuccessfulScreen = ({
  image,
  title,
  description,
  buttonSecondaryText,
  onClickButtonSecondary,
  onClickButtonPrimary,
  primaryButton,
  className,
}) => {
  const renderText = useCallback((value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return <FormattedMessage {...value} />;
  }, []);

  return (
    <div className={classNames('screen-successful view-center', className)}>
      <div className="text-center">
        <img src={image} />
        <h4 className="title">{renderText(title)}</h4>
        <p className="description">{renderText(description)}</p>
      </div>
      <div className="text-center">
        {buttonSecondaryText && (
          <MyButton
            onClick={onClickButtonSecondary}
            className="btn-secondary-custom mx-10"
          >
            {renderText(buttonSecondaryText)}
          </MyButton>
        )}
        <MyButton
          onClick={onClickButtonPrimary}
          className="btn-primary-custom my-30"
        >
          {renderText(primaryButton)}
        </MyButton>
      </div>
    </div>
  );
};

SuccessfulScreen.propTypes = {
  image: PropTypes.string,
  title: PropTypes.object,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonSecondaryText: PropTypes.string,
  primaryButton: PropTypes.object,
  onClickButtonSecondary: PropTypes.func,
  onClickButtonPrimary: PropTypes.func,
};

SuccessfulScreen.defaultProps = {
  image: SuccessfulImage,
  title: { id: 'common.successful' },
  primaryButton: { id: 'common.complete' },
  onClickButtonSecondary: () => {},
  onClickButtonPrimary: () => {},
};

export default SuccessfulScreen;
